module.exports = __webpack_public_path__ + "img/logo.9fba390a.svg";